import clsx from 'clsx';
import { memo } from 'react';
import logo from 'app/assets/icons/sidebar/logo.svg';
import collapseMenuIcon from 'app/assets/icons/sidebar/collapse-menu.svg';
import NavbarToggleButton from 'app/fuse-layouts/shared-components/NavbarToggleButton';
import SidebarNavigation from 'app/fuse-layouts/shared-components/SidebarNavigation/SidebarNavigation';

function NavbarStyle1Content(props) {
  return (
    <div
      className={clsx(
        'vtwo:flex vtwo:h-full vtwo:flex-col vtwo:overflow-hidden vtwo:rounded-2xl vtwo:bg-[#16181b]',
        props.className
      )}
    >
      <div className="vtwo:flex vtwo:h-12 vtwo:shrink-0 vtwo:items-center vtwo:justify-between vtwo:px-4 vtwo:pt-2">
        <img className="vtwo:h-[18px]" src={logo} alt="Healthera" />
        <NavbarToggleButton className="vtwo:size-7 vtwo:p-0 vtwo:hover:bg-white/10!">
          <img
            className="vtwo:size-4 vtwo:brightness-0 vtwo:invert vtwo:opacity-60"
            src={collapseMenuIcon}
            alt="Collapse menu"
          />
        </NavbarToggleButton>
      </div>

      <div className="vtwo:flex-1 vtwo:overflow-y-auto vtwo:overscroll-contain vtwo:px-2 vtwo:pt-4 vtwo:pb-10">
        <SidebarNavigation />
      </div>
    </div>
  );
}

export default memo(NavbarStyle1Content);
